type OrderDisplayReferenceInput = {
  orderId: string;
  varyBasketId?: number | string | null;
  varyFileId?: number | string | null;
};

export const getOrderDisplayReference = ({ orderId, varyBasketId, varyFileId }: OrderDisplayReferenceInput): string =>
  String(varyFileId ?? varyBasketId ?? orderId);
